const links = {
    forms: {
        VIC: {
            electricityAbolishmentForm: "https://www.globirdenergy.com.au/shared-assets/pdf/abolishment-of-electricity-supply.pdf",
            ewrForm: "https://www.globirdenergy.com.au/shared-assets/pdf/Blank-EWR.pdf",
            lifeSupportForm: "https://www.globirdenergy.com.au/shared-assets/pdf/Life-Support-Form-2025.pdf",
            lifeSupportConcessionForm: "https://www.globirdenergy.com.au/shared-assets/pdf/Life-Support-Concession_Application_Form.pdf",
            medicalCoolingConcessionForm: "https://www.globirdenergy.com.au/shared-assets/pdf/Medical-Cooling-Concession-Form.pdf"
        },
        NSW: {
            lifeSupportRebateForm: "https://www.globirdenergy.com.au/shared-assets/pdf/NSW-Life-Support-Rebate-2025.pdf",
            medicalEnergyRebateForm: "https://www.globirdenergy.com.au/shared-assets/pdf/NSW-Medical-Energy-Rebate-2025.pdf",
        },
        ALL: {
            gasApplicationForm: "https://www.globirdenergy.com.au/shared-assets/pdf/GloBird-Gas-Application-Form-2026.pdf",
            gasApplicationFormExternal: "https://quote.globirdenergy.com.au/forms/gasapplicationform",
            directDebitForm: "https://www.globirdenergy.com.au/wp-content/uploads/securepdfs/2023/12/2023-DD-form-digital-New.pdf",
            jointOwnerApplicationForm: "https://www.globirdenergy.com.au/shared-assets/pdf/2026-GloBird-F-JointAccount.pdf",
        }
    },
    terms: {
        directDebitTerms: "https://globirdcdn.azureedge.net/Globird_Direct_Debit_Term_And_Conditions.pdf"
    },
    corporateWebsite: {
        privacyPolicy: "https://www.globirdenergy.com.au/legal/privacy/",
        legal: "https://www.globirdenergy.com.au/legal/",
        myAccountFaqSection: "https://www.globirdenergy.com.au/help-support/faq/#MyAccount",
        referral: "https://www.globirdenergy.com.au/refer/",
        tariffTimetables: "https://www.globirdenergy.com.au/legal/flexible/",
        estimation: "https://www.globirdenergy.com.au/estimatebill/",
        howToReadMeterDetails: "https://www.globirdenergy.com.au/how-do-i-read-my-meter/#reading-your-meter",
        howToReadMeterPage: "https://www.globirdenergy.com.au/how-do-i-read-my-meter/",
        fees: "https://www.globirdenergy.com.au/fees/",
        legalFees: "https://www.globirdenergy.com.au/legal/fees/",
        movingHome: "https://www.globirdenergy.com.au/moving-home/",
        landingPage: "https://www.globirdenergy.com.au/",
        concessions: "https://www.globirdenergy.com.au/concessions/",
        contactUs: "https://www.globirdenergy.com.au/contact-us/",
        myFirstBill: "https://www.globirdenergy.com.au/my-first-bill/",
        understandingYourBill: "https://www.globirdenergy.com.au/understanding-your-bill/",
        myMonthlyBill: "https://www.globirdenergy.com.au/my-monthly-bill/",
        faq: "https://www.globirdenergy.com.au/help-support/faq/"
    },
    oss: {
        landingPage: "https://quote.globirdenergy.com.au/"
    },
    concession: {
        saConcessionInfo: "https://www.sa.gov.au/topics/care-and-support/concessions/household-concessions/energy-bill-concessions"
    },
    email: {
        cs: "cs@globirdenergy.com.au"
    },
    phone: {
        general: "tel:+61133456",
        generalDisplay: "133 456",
        international: "tel:+61388138899",
        internationalDisplay: "03 8813 8899",
        chinese: "tel:+611800516888",
        chineseDisplay: "1800 516 888",
        interpreter: "tel:+61131450",
        interpreterDisplay: "131 450"
    }
};

export default links;